module.exports = __webpack_public_path__ + "static/img/xt-cn.ce66d28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/XT/xt-cn.png
// module id = 0rfK
// module chunks = 0